export const WIDGET_Z_INDEX = 1000;
export const TOAST_Z_INDEX = WIDGET_Z_INDEX + 1;
// Drift workspace key for the live chat, shared by the legacy ChatWidget (which preloads Drift when the
// browser goes idle) and the redesign RedesignChatWidget (which loads it on click instead).
export const DRIFT_PROVIDER_KEY = 'uvceibmepai6';
